import { useQuery, useMutation, } from "@tanstack/react-query";
export const createOrganizationsQueries = (requests, queryClient) => ({
    useListOrganizations: (params, options = {}) => useQuery({
        queryKey: ["organizations", params],
        queryFn: async ({ queryKey }) => {
            const [_key, params] = queryKey;
            return requests.listOrganizations(params);
        },
        ...options,
    }),
    useFindOrganization: (params, options = {}) => useQuery({
        queryKey: ["organizations", params],
        queryFn: async ({ queryKey }) => {
            const [_key, params] = queryKey;
            return requests.findOrganization(params);
        },
        ...options,
    }),
    useUpdateOrganization: (options = {}) => useMutation({
        ...options,
        mutationFn: (attrs) => {
            return requests.updateOrganization(attrs);
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["organization"] });
            options.onSuccess?.(null, null, null);
        },
    }),
});
//# sourceMappingURL=index.js.map